<template>
    <div>
        <div class="home">
            <div class="home-background"></div>
            <div class="bg-home">
                <div class="vertical-center">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <h1 class="lax" data-lax-scale="0 1, (document.body.scrollHeight*0.3) 1.8" data-lax-opacity="0 1,(document.body.scrollHeight*0.3) 0" id="headliner">
                                    <span data-aos="zoom-out" data-aos-easing="ease-in" data-aos-delay="100" data-aos-duration="300">WE MAKE</span>
                                    <br/>
                                    <span data-aos="fade-in" data-aos-easing="ease-in" data-aos-delay="300" data-aos-duration="1000" class="text-magnify">AWESOME</span>
                                    <br/>
                                    <span data-aos="zoom-out" data-aos-easing="ease-in" data-aos-delay="100" data-aos-duration="300">SOFTWARE</span>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sticky-bottom">
                <nexticon title='HOW' vcolor='#FFFFFF' :bounce='true' :delay='800'></nexticon>
            </div>
        </div>
        <div class="how-more" id="how">
            <div class="bg-home-more">
                <div class="container-fluid">
                    <div class="row justify-content-md-center">
                        <div class="col-md-6 col-md-auto">
                            <div data-lax-anchor="#how" data-lax-scale="(document.body.scrollHeight*0.2) 1, (document.body.scrollHeight*0.5) 0" id="howliner">
                                <h2>HOW</h2>
                                 <p>
                                    REQUIREMENTS -> ANALYSIS -> WIREFRAMING -> DESING
                                </p>
                                 <p>
                                    CODING -> TESTING -> DEPLOY -> MAINTENANCE
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <nexticon title='WHY' vcolor='#000000' :bounce='true' :delay='200'></nexticon>

            </div>
        </div>
        <div class="why-more" id="why">
            <div class="bg-home-more">
                <div class="container-fluid">
                    <div class="row justify-content-md-center">
                        <div class="col-md-6 col-md-auto">
                            <div data-lax-scale="0 0, (document.body.scrollHeight*0.5) 1" data-lax-opacity="0 1,(document.body.scrollHeight*0.5) 1" id="whyliner">
                                <h2>WHY ?</h2>
                                <br />
                                <heartsvg vcolor='#FF6347' :vopacity='0.9' :bounce='true' :vwidth='100' :vheight='100'>
                                    <h3>BECAUSE WE LOVE IT</h3>
                                    <p>Software is not only our Business, but our PASSION.</p>
                                    <p>Our Work is developing Software and good Software is an oportunity to Reshape your business.</p>
                                </heartsvg>
                                <router-link class="btn btn-link" to="/contacts">Contact us for your next project</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import nexticon from './NextIcon'
import heartsvg from './HeartSVG'
import lax from 'lax.js'

export default {
    name: 'Home',
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        },
        mounted: function () {
            lax.addElement(document.getElementById('gooo')) // add your element to lax when it mounts
            lax.addElement(document.getElementById('headliner')) // add your element to lax when it mounts
            lax.addElement(document.getElementById('howliner')) // add your element to lax when it mounts
            lax.addElement(document.getElementById('whyliner')) // add your element to lax when it mounts
        },
        components: {
            nexticon,
            heartsvg
        }
    }
</script>

<style lang="scss">
.home{
    display: block; min-height: 750px; height: 100vh; position:relative;
    .home-background{
        background: url('~@/assets/img/bg-software.jpg'); background-position:center; background-size:cover; margin:0; width: 100%; height: 100%; z-index:0; overflow: hidden;position:absolute;
    }
    .bg-home{
        background: url('~@/assets/img/bg-home.png'); background-position:center; background-size:cover; margin:0; width: 100%; height: 100%; z-index:1; position:absolute; min-height: 750px;
        h1{
            color: $white; font-size: 80px; font-weight: 800;
            span.text-magnify{
                color: rgba(255,255,255,0.8);
                font-size: 120px; text-shadow: 8px 8px 0 rgba(110, 50, 40,0.9);
            }
        }

        a{
            color: #FFF; font-size: 22px;
        }
    }

    .sticky-bottom {
        position: absolute; z-index: 1000; bottom: 40px; transform: translate(0, -50%); left:50%; transform: translate(-50%, -50%);
    }

}

.how-more{
    .bg-home-more{
        background: #EEE; margin:0; width: 100%; height: 100%; z-index:1; position:relative; padding: 75px 0;
        h1{
            color:#FFF; font-size: 100px; font-weight: 800;
        }

        a{
            color: #FFF; font-size: 22px;
        }
    }
}

.why-more{
    display: block;
    .bg-home-more{
        background: $white; margin:0; width: 100%; height: 100%; z-index:1; position:relative; padding: 75px 0;
        h1{
            color:#FFF; font-size: 100px; font-weight: 800;
        }

        a{
            color: #FFF; font-size: 22px;
        }
    }
}

// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) {
    .home{
        .bg-home{
            h1{
                font-size: 45px;
                span.text-magnify{
                    font-size: 65px; text-shadow: 4px 4px 0 rgba(110, 50, 40,0.9);
                }
            }
        }
        .sticky-bottom {
            bottom: 20px;
        }
    }
}

// Small devices (landscape phones, less than 768px)
@media (max-width: 767.98px) {

}

// Medium devices (tablets, less than 992px)
@media (max-width: 991.98px) {

}

// Large devices (desktops, less than 1200px)
@media (max-width: 1199.98px) {

}

</style>
